export const TrafficInfoWidgetId = 'TrafficInfoWidget';

export enum TrafficInfoWidgetAttributes {
  DUMMY_DATA = 'dummyData',
  DUMMY_AREA_INFO = 'dummyAreaInfo',
}
